import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination, Navigation } from "swiper/modules";

export default function App() {
  return (
    <>
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
        navigation={true}
        modules={[Navigation]}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
        className="mySwiper flash-slider"
      >
        <SwiperSlide className="benifit-slider-card1">
          <div className="benifit-border">
            <img src={require("../../image/Flash_loan/income-gen-icon.webp")} />
            <h3> Passive Income Generation</h3>
            <p>
              Flash loan arbitrage bot development offers the opportunity to
              generate passive income by using automated trading strategies to
              exploit price discrepancies across cryptocurrency exchanges. With
              minimal effort required once the bot is set up, traders can earn
              consistent profits without actively monitoring the markets.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide className="benifit-slider-card1">
          <div className="benifit-border">
            {" "}
            <img src={require("../../image/Flash_loan/Market-icon.webp")} />
            <h3> 24/7 Market Coverage</h3>
            <p>
              Flash loan arbitrage bots operate round-the-clock, providing
              continuous market coverage to capitalise on arbitrage
              opportunities across different time zones and trading sessions.
              This ensures that traders can capture profitable trades at any
              hour of the day, even when they are not actively engaged in
              trading activities.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide className="benifit-slider-card1">
          <div className="benifit-border">
            {" "}
            <img
              src={require("../../image/Flash_loan/reduced-trade-icon.webp")}
            />
            <h3> Revealing the Hidden Order</h3>
            <p>
              DeFi markets, with their myriad protocols and fragmented liquidity
              pools, can appear messy. Arbitrage bots act as oracles, discerning
              subtle patterns and hidden orders within this apparent chaos. They
              reveal the true, underlying value of assets by exploiting
              momentary deviations from balance.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide className="benifit-slider-card1">
          <div className="benifit-border">
            {" "}
            <img
              src={require("../../image/Flash_loan/Increase-capital-icon.webp")}
            />
            <h3>The Catalyst of Constant Evolution</h3>
            <p>
              Flash loan arbitrage bots drive constant evolution within the DeFi
              ecosystem. Their persistent tracking of profit pressures protocols
              to optimize their pricing mechanisms, improve liquidity, and
              enhance overall efficiency.
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
}
